import { css } from 'linaria';

export const sectionStyles = css`
  width: 100%;
`;
